import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18next';
import './CommentTitle.css';
import Anchor from '../Anchor/Anchor';

const CommentTitle = ({
  name,
  repliedToName,
  userId,
  authorIsUser,
  isReply
}) => {
  const profileUrl = authorIsUser
    ? '/profile/my#contents'
    : `/users/${userId}#contents`;

  const renderCommentAuthor = () => {
    return name ? (
      <Anchor href={profileUrl} newTab={false}>
        {name}
      </Anchor>
    ) : (
      I18n.t('deactivatedUser')
    );
  };

  return (
    <p styleName="commentTitle">
      {renderCommentAuthor()}
      {isReply && (
        <>
          <span>{I18n.t('repliedTo')}</span>
          {repliedToName || I18n.t('deactivatedUser')}
        </>
      )}
    </p>
  );
};

CommentTitle.propTypes = {
  name: PropTypes.string,
  userId: PropTypes.number,
  repliedToName: PropTypes.string,
  authorIsUser: PropTypes.bool.isRequired,
  isReply: PropTypes.bool
};

CommentTitle.defaultProps = {
  repliedToName: null,
  name: null,
  isReply: false,
  userId: null
};

export default CommentTitle;
